module.exports = __webpack_public_path__ + "static/12.1-386e71a679db214ee3f08ac9e638a218.jpg";